import {
  AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef,
  Component, ElementRef, OnInit, ViewChild, ViewContainerRef
} from '@angular/core';
import { WizBasePopUp } from '../wiz-base-popup';
import { WizComponentManager } from '../../../services/core/component/wiz-component.manager';
import { WizButton } from '../../controls/button/wiz-button/wiz-button';
import { ConfirmationResultObj } from '../../../obj/popup/confirmation-result.obj';
import { WizLabel } from '../../controls/wiz-label/wiz-label';
import { CONFIRMATION_MODE, CONFIRMATION_RESULT, WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import { WizEventManager } from '../../../events/wiz-event.manager';
import { WizEvent } from '../../../events/wiz-event';

/**
 * renderer par défaut de la popUp de confirmation
 * Author LMA
 */
@Component({
  // tslint:disable-next-line: component-selector
  selector: 'confirmation-pop-renderer',
  templateUrl: './confirmation-pop.renderer.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationPopRenderer extends WizBasePopUp implements OnInit, AfterViewInit {

  @ViewChild('lblTitle', {read: WizLabel, static: false}) lblTitle: WizLabel; // titre par défaut
  @ViewChild('lblDetail', {read: WizLabel, static: false}) lblDetail: WizLabel; // détail par défaut
  /** zone de rendu complémentaire */
  @ViewChild('rendererContainer', {read: ViewContainerRef, static: true}) private rendererContainer: ViewContainerRef;
  @ViewChild('goodButton', {read: WizButton, static: false}) private goodButton: WizButton;
  @ViewChild('badButton', {read: WizButton, static: false}) private badButton: WizButton;

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  public showBadButton: boolean = true; // on affiche le bouton "négatif" (hors mode OK)

  public goodLabel : string; // le libellé bien
  public badLabel: string; // le libellé méchant


  public titleStr : string =''; // titre issu des parameters
  public contentStr: string =''; // détail issu des parameters

  // le stockage des valeurs de retour
  private goodValue: CONFIRMATION_RESULT;
  private badValue : CONFIRMATION_RESULT;

  ngOnInit(): void {
    // alimentation du titre et du détail
    this.titleStr = this.parameters.title;
    this.contentStr = this.parameters.contentText;

    // rendu custom
    if (this.parameters.customFactory) {

      const rendererData: any = this.parameters.customFactoryData ? this.parameters.customFactoryData : this.datas;

      WizComponentManager.instance.addChildTo(this.parameters.customFactory,
         this.rendererContainer, {instanceProperties: { data: rendererData }});
    }

    switch(this.parameters.confirmMode) {
      case CONFIRMATION_MODE.CONFIRM_CANCEL :
        this.goodLabel = '$.common.confirm.$';
        this.badLabel = '$.common.cancel.$';
        this.goodValue = CONFIRMATION_RESULT.CONFIRM;
        this.badValue = CONFIRMATION_RESULT.CANCEL;
        break;
      case CONFIRMATION_MODE.YES_NO :
        this.goodLabel = '$.common.yes.$';
        this.badLabel = '$.common.no.$';
        this.goodValue = CONFIRMATION_RESULT.YES;
        this.badValue = CONFIRMATION_RESULT.NO;
        break;
      case CONFIRMATION_MODE.OK :
        this.goodLabel = '$.common.ok.$';
        this.badLabel = CONFIRMATION_RESULT.OK;
        this.showBadButton = false;
        break;
    }
  }

  /** mise en place du listener sur les boutons */
  ngAfterViewInit(): void {
    WizEventManager.addListener(this, this.goodButton, WIZ_EVENT_TYPE.CLICK, this.onButtonClick);
    if(this.badButton) {
      WizEventManager.addListener(this, this.badButton, WIZ_EVENT_TYPE.CLICK, this.onButtonClick);
    }

    // trap Enter / escape
    WizEventManager.addListener(this, this.elementRef, 'keydown', this.onKeyDown);
  }

  /** écouteur des events sur les boutons */
  private onButtonClick(e:WizEvent): void {
    if(e.component === this.goodButton) {
      this.exit(this.goodValue);
    } else if (e.component === this.badButton) {
      this.exit(this.badValue);
    }
  }

  /** écouteur des events keyboard */
  private onKeyDown(e:KeyboardEvent): void {
    const keyCode = e.key;
    if (keyCode === 'Enter') {
      this.exit(this.goodValue);
    } else if (keyCode === 'Escape' && this.showBadButton) { // pas de sortie si pas de négatif
      this.exit(this.badValue);
    }
  }

  /** sortie OK|YES|CONFIRM ou CANCEL/NO  */
  private exit(value:CONFIRMATION_RESULT): void {

    const result: ConfirmationResultObj = new ConfirmationResultObj();
    result.data = this.datas;
    result.result = value;

    WizEventManager.removeListener(this, this.goodButton, WIZ_EVENT_TYPE.CLICK);
    if(this.badButton) {
      WizEventManager.removeListener(this, this.badButton, WIZ_EVENT_TYPE.CLICK);
    }
    
    // trap Enter / escape
    WizEventManager.removeListener(this, this.elementRef, 'keydown');

    this.callback(result);

    // hide popup
    this.parameters.hide();
  }
}
